const canHaveTargetMedia = name => {
  return (
    name.toLowerCase().endsWith('.jpg') || name.toLowerCase().endsWith('.jpeg')
  )
}

export default canHaveTargetMedia



// WEBPACK FOOTER //
// ./src/utils/canHaveTargetMedia.js